import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { callAPI, getLocalValue, IsSmallScreen, LoacalVariables, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../commonFunctions/PermissionManger";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import ConfirmDialog, { useConfirmDialog } from "../../Components/Confirmation/ConfirmDialog";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../StateManagement/actions";
interface IMyTaskList {
    transForm?: boolean
    title?: string
}
export const MyTaskList: React.FC<IMyTaskList> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getTaskPermission;
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const {
        open,
        title,
        onConfirm,
        handleClose,
        openConfirmDialog,
    } = useConfirmDialog();
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    useEffect(() => {
        updateMainHeader("Tasks");
        breadCrumbsStore.updateBreadCrumbs([
            { "Tasks": "" },
        ]);
    });
    const source = {
        url: "tasks/search",
        page: 1,
        pageSize: 10,
        filter: props?.transForm ? [
            {
                "field": "AssignedToUserId",
                "operator": "eq",
                "value": getLocalValue(LoacalVariables.UserId)
            }
        ] : [{
                "field": "AssignedToUserId",
                "operator": "neq",
                "value": getLocalValue(LoacalVariables.UserId)
            }],
        sort: [
            {
                "field": "UpdatedAt",
                "direction": "desc"
            }],
    };
    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`tasks`, Method.DELETE, null, id);
        dispatch(resetDataComponent('taskMainListGrid'));
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };
    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/task/edit/${row?.id}`)
        }
        else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }
    };
    const columns: IColumns[] = [
        {
            header: "Task",
            fieldName: "taskName",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Task Date",
            fieldName: "customDate",
            type: 'date'
        },
        {
            header: "Task type",
            fieldName: "taskType",
            type: 'default'
        },
        {
            header: "Priority",
            fieldName: "priority",
            type: 'default'
        },
 {
            header: "Note",
            fieldName: "notes",
            tooltip:true,
            type: 'default'
        },
        // {
        //     header: "Actions",
        //     fieldName: "actions",
        //     type: "action",
        //     actions: [edit ? "Edit" : undefined, remove ? "Delete" : undefined].filter(Boolean),
        //     actionCallback: (action, row) => handleAction(action, row),

        // },
    ];

    const mobColumns: IOrderColumns[] = [
        {
            header: "Task",
            fieldName: "taskName",
            tooltip: true,
            type: 'default',
            labelSx: { fontWeight: 'bold' }
        },
        {
            header: "Task type",
            fieldName: "taskType",
            type: 'default'
        },
        {
            header: "Priority",
            fieldName: "priority",
            type: 'default',
            sm: 4,
        },
        {
            header: "Date",
            fieldName: "customDate",
            type: 'date',
            labelSx: { marginLeft: 2 },
            sm: 8,
            isBoderRadious: true
        },



        // {
        //     header: "Actions",
        //     fieldName: "actions",
        //     type: "action",
        //     actions: [edit ? "Edit" : undefined].filter(Boolean),
        //     actionCallback: (action, row) => handleAction(action, row),

        // },
    ];
    const handleClick = () => {
        navigate('/task/create')
    }
    const isSameDate = (a: Date, b: Date) =>
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();
    const transFormData = (data: any[]) => {
        const myTaskList: any[] = [];
        const today = new Date();

        if (data) {
            data.forEach((item: any) => {
                const itemDate = new Date(item.customDate);

                if (isSameDate(itemDate, today)) {
                    myTaskList.push(item);
                }
            });
        }

        return myTaskList;
    };
    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="myTaskMainListGrid"
                        title={props?.title ? props.title : "Tasks"}
                        columns={columns}
                        source={source}
                        transFormData={props?.transForm ? transFormData : undefined}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }

                </Grid>
                    : <PermissionDenied />
                }
                <ConfirmDialog
                    open={open}
                    title={title}
                    onConfirm={onConfirm}
                    onClose={handleClose}
                />
            </Grid>
        </>
    )
})